import { ReactElement } from 'react';
import { RegisteredAssetModel } from '@casops/store/apis/registeredAssetsApi';
import styles from './AssetNameCellRenderer.module.scss';
import classNames from 'classnames';

type AssetNameCellRendererProps = {
  value: string;
  data: RegisteredAssetModel;
};

export const AssetNameCellRenderer = (props: AssetNameCellRendererProps): ReactElement => {
  const { value, data } = props;
  const isMisMatch = data?.stN === false;

  return <span className={classNames(isMisMatch && styles.mismatch)}>{value}</span>;
};
